<template>
  <modal-dialog :visible="isVisible" :id="modalDialogId" class="download-dialog">
    <div slot="header">
      <h5>{{ title }}</h5>
    </div>

    <div slot="body">
        <div class="custom-control custom-radio">
            <input v-model="selectedImageSize" type="radio" id="imageSizeOriginal" name="imageSize" class="custom-control-input" value="full">
            <label class="custom-control-label" for="imageSizeOriginal">
                {{ translate('label.radio.image_size.original') }}
            </label>
        </div>
        <div class="custom-control custom-radio">
            <input v-model="selectedImageSize" type="radio" id="imageSizeL" name="imageSize" class="custom-control-input" value="pct:50">
            <label class="custom-control-label" for="imageSizeL">
                {{ translate('label.radio.image_size.l') }}
            </label>
        </div>
        <div class="custom-control custom-radio">
            <input v-model="selectedImageSize" type="radio" id="imageSizeM" name="imageSize" class="custom-control-input" value="pct:25">
            <label class="custom-control-label" for="imageSizeM">
                {{ translate('label.radio.image_size.m') }}
            </label>
        </div>

         <div class="license">
            <strong>{{ translate('label.license') }}</strong>:
            CC-BY-NC
        </div>

         <div class="how-to-quote">
            <strong>{{ translate('label.how_to_quote') }}</strong>:<br />
            {{ howToQuote }}
        </div>
    </div>

    <div slot="footer">
      <button type="button" class="btn btn-light" @click="onDownload"><img src="/img/download-trans.svg"> {{ translate('label.modal.button.download') }}</button>
    </div>
  </modal-dialog>
</template>

<script>
    export default {
        props: {
            title: { type: String, required: true, default: "Download" },
            howToQuote: { type: String, required: true, default: "" }
        },

        created() {
            EventDispatcher.listen('showDownloadDialog', () => {
                EventDispatcher.fire('showDialog' + this.modalDialogId, true);
            });
        },
        
       data() {
           return {
               isVisible: false,
               modalDialogId: 'downloadModalDialog',
               selectedImageSize: 'pct:25'
           }
       },

        methods: {
            onDownload() {
                EventDispatcher.fire('showDialog' + this.modalDialogId, false);
                EventDispatcher.fire('downloadImage', this.selectedImageSize);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .license {
        margin-top: 24px;
        font-size: 0.9rem;
    }
    .how-to-quote {
        margin-top: 12px;
        font-size: 0.9rem;
    }

    @media print {
        .download-dialog {
            display: none;
        }
    }
</style>